import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { ArrowRight, Phone } from "@phosphor-icons/react";
import { MEDIA, COMPANY } from "@/data/company";

export default function Hero() {
  return (
    <section id="home" className="relative" data-testid="hero-section">
      <div className="relative min-h-[92vh] w-full overflow-hidden">
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${MEDIA.hero})` }}
          aria-hidden
        />
        <div className="absolute inset-0 hero-overlay" aria-hidden />

        {/* Grid lines */}
        <div
          className="absolute inset-0 opacity-[0.08] pointer-events-none"
          style={{
            backgroundImage:
              "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
            backgroundSize: "80px 80px",
          }}
          aria-hidden
        />

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-[92vh] flex flex-col justify-end pb-16 pt-32">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="max-w-4xl"
          >
            <div className="inline-flex items-center gap-2 mb-8 px-3 py-2 bg-white/10 backdrop-blur border border-white/20">
              <span className="w-2 h-2 bg-[#F59E0B] animate-pulse" />
              <span className="text-white/90 text-xs uppercase tracking-[0.25em] font-bold">
                Est. Kanpur • Since Decades
              </span>
            </div>

            <h1
              data-testid="hero-title"
              className="font-display font-black text-white text-5xl sm:text-6xl lg:text-8xl leading-[0.9] tracking-tighter"
            >
              Moving India's <br />
              <span className="text-gold-gradient">Payload</span> with Precision.
            </h1>

            <p className="mt-8 max-w-2xl text-white/85 text-lg lg:text-xl font-medium leading-relaxed">
              {COMPANY.subtagline}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#quote"
                data-testid="hero-cta-quote"
                className="inline-flex items-center gap-3 bg-[#EA580C] text-white font-bold uppercase tracking-wider text-sm px-7 py-4 shadow-brutal hover-shadow-brutal transition-brutal"
              >
                Get a Quote
                <ArrowRight size={18} weight="bold" />
              </a>
              <a
                href={`tel:${COMPANY.owners[0].phone}`}
                data-testid="hero-cta-call"
                className="inline-flex items-center gap-3 bg-white text-slate-900 font-bold uppercase tracking-wider text-sm px-7 py-4 border-2 border-white transition-brutal hover:bg-transparent hover:text-white"
              >
                <Phone size={18} weight="bold" />
                Call Dispatch
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Marquee ribbon */}
      <div className="bg-[#0F172A] border-y-2 border-[#F59E0B]">
        <Marquee gradient={false} speed={40} className="py-5">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="flex items-center gap-6 mx-6">
              <span className="font-display font-black uppercase text-white text-2xl md:text-3xl tracking-widest">
                Government Payload
              </span>
              <span className="w-3 h-3 bg-[#EA580C] rotate-45" />
              <span className="font-display font-black uppercase text-white/70 text-2xl md:text-3xl tracking-widest">
                Pan-India Delivery
              </span>
              <span className="w-3 h-3 bg-[#EA580C] rotate-45" />
              <span className="font-display font-black uppercase text-white text-2xl md:text-3xl tracking-widest">
                Full Truck Load
              </span>
              <span className="w-3 h-3 bg-[#EA580C] rotate-45" />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
